import { render, staticRenderFns } from "./team.vue?vue&type=template&id=760916a4&scoped=true&"
import script from "./team.vue?vue&type=script&lang=ts&"
export * from "./team.vue?vue&type=script&lang=ts&"
import style0 from "./team.vue?vue&type=style&index=0&id=760916a4&scoped=true&lang=css&"
import style1 from "./team.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760916a4",
  null
  
)

export default component.exports